import { ComplianceRequirement } from 'types/compliance';

export interface ComplianceData {
  message: string;
  ctaText: string;
  shouldShow: boolean;
}

export interface FormatComplianceOptions {
  requirement?: ComplianceRequirement;
  signInMessage: string;
  signInCta: string;
  termsMessage: string;
  termsCta: string;
}

export function formatCompliance(options: FormatComplianceOptions): ComplianceData {
  const { requirement, signInMessage, signInCta, termsMessage, termsCta } = options;

  if (requirement === ComplianceRequirement.SIGN_IN) {
    return {
      message: signInMessage,
      ctaText: signInCta,
      shouldShow: true,
    };
  }

  if (requirement === ComplianceRequirement.TERMS_OF_USE) {
    return {
      message: termsMessage,
      ctaText: termsCta,
      shouldShow: true,
    };
  }

  return {
    message: '',
    ctaText: '',
    shouldShow: false,
  };
}
